<template>
    <div>
<!--        <span class="timeline-key">Airline </span> : {{extra.airline.name}}  <br>-->
<!--        <span class="timeline-key">Airport </span> : {{extra.airport.name}}  <br>-->
        <span class="timeline-key">Remarks </span> : {{extra.remarks}}  <br>
        <span class="timeline-key">File (if any) </span> : <file-display :src="extra.file"> </file-display> <br>
    </div>
</template>

<script>
    import FileDisplay from "../../FileDisplay";

    export default {
        name: "EntryRefuse",
        props: ['extra', 'days', 'user'],
        components: {FileDisplay},
    }
</script>
